/* eslint-disable jira/filename-case */
import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from './createJpdExperience.tsx';
import type { JPDExperience } from './ExperienceMetadataExtra.types.tsx';

export const pageSegmentLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.timeline-view', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const timelineDragExperience: UFOExperience = new UFOExperience('jpd.timeline.drag', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.Custom,
});

export const timelineDropExperience: UFOExperience = new UFOExperience('jpd.timeline.drop', {
	type: ExperienceTypes.Operation,
	performanceType: ExperiencePerformanceTypes.Custom,
});

export const timelineNextDragExperience: UFOExperience = new UFOExperience(
	'jpd.timeline-next.drag',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);

export const timelineNextDropExperience: UFOExperience = new UFOExperience(
	'jpd.timeline-next.drop',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	},
);
